export default __webpack_public_path__ + "static/media/06.18.25 Minutes Spcl Mtg.712c947c.pdf";